import type { PrivateContentDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/content';
import ViewHippoInformationModal from '../../../../shared_components/ViewHippoInformationModal/ViewHippoInformationModal';
import type { TableInformation } from '../../../../config/flavourConfig';

const getPrivateContentInsuranceSumsCoverableDetailsConfig = (
    contentCoverable: PrivateContentDTO
): TableInformation => {
    return {
        title: 'Forsikringssummer',
        rowsInformation: [
            {
                name: 'Guld, sølv, smykker mv.',
                fieldValue: contentCoverable.goldSilverJewelryProtection,
                valueType: 'amount',
                labelType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-GOLD-SILVER-JEWELRY-TITLE',
                        description:
                            'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-GOLD-SILVER-JEWELRY-DESCRIPTION'
                    }
                }
            },
            {
                name: 'Designermøbler og -lamper',
                fieldValue: contentCoverable.designerFurnitureSum,
                valueType: 'amount',
                labelType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-FURNITURE-TITLE',
                        description: 'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-FURNITURE-DESCRIPTION'
                    }
                }
            },
            {
                name: 'Øvrigt indbo',
                fieldValue: contentCoverable.remainingContentSum,
                hidden: contentCoverable.doYouCollectAnything === 'Yes180960OrMore',
                valueType: 'amount',
                labelType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-OTHER-CONTENT-TITLE',
                        description:
                            'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-OTHER-CONTENT-DESCRIPTION'
                    }
                }
            },
            {
                name: 'Forsikringssum i alt',
                fieldValue: contentCoverable.totalContentSum,
                hidden: !contentCoverable.totalContentSum,
                labelType: 'bold',
                valueType: 'amount'
            },
            {
                name: `${'Øvrigt indbo (fx tøj, køkkenudstyr, malerier og it-udstyr)'}
                    ${'samt værdien af den dyreste genstand du har oplyst os om, at du har'}`,
                fieldValue: contentCoverable.remainingContentSum,
                hidden: contentCoverable.doYouCollectAnything !== 'Yes180960OrMore',
                valueType: 'amount',
                labelType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-OTHER-CONTENT-TITLE',
                        description:
                            'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-OTHER-CONTENT-DESCRIPTION'
                    }
                }
            },
            {
                name: 'Dyreste genstand blandt øvrigt indbo må maksimalt have en værdi på',
                fieldValue: contentCoverable.mostExpensiveItemSum,
                hidden: contentCoverable.remainingContentSum !== 'Ubegrænset',
                valueType: 'amount',
                labelType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-EXPENSIVE-ITEM-TITLE',
                        description:
                            'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-EXPENSIVE-ITEM-DESCRIPTION'
                    }
                }
            },
            {
                name: 'Samlinger blandt øvrigt indbo (fx vin, stålure, våben, modeltog) må maksimalt have en værdi på',
                fieldValue: contentCoverable.collectionSum,
                hidden: contentCoverable.remainingContentSum !== 'Ubegrænset',
                valueType: 'amount',
                labelType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-COLLECTIONS-TITLE',
                        description: 'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-COLLECTIONS-DESCRIPTION'
                    }
                }
            },
            {
                name: 'Cykler (pr. cykel)',
                fieldValue: contentCoverable.bicycleSum,
                valueType: 'amount',
                labelType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-CON-HIGHLIGHTED-TEXT-MODAL-BICYCLES-TITLE',
                        description: 'DSS-CON-HIGHLIGHTED-TEXT-MODAL-BICYCLES-DESCRIPTION'
                    }
                }
            },
            {
                name: 'Cykeldele',
                fieldValue: contentCoverable.bicyclePartsSum,
                valueType: 'amount',
                labelType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-CON-HIGHLIGHTED-TEXT-MODAL-BICYCLE-PARTS-TITLE',
                        description:
                            'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-BICYCLE-PARTS-DESCRIPTION'
                    }
                }
            },
            {
                name: 'Maksimal erstatning for cykler og cykeldele pr. skade',
                fieldValue: contentCoverable.maxBikeSum,
                valueType: 'amount'
            },
            {
                name: 'Bagage',
                fieldValue: contentCoverable.baggageSum,
                valueType: 'amount',
                labelType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-LUGGAGE-TITLE',
                        description: 'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-LUGGAGE-DESCRIPTION'
                    }
                }
            }
        ]
    };
};

export { getPrivateContentInsuranceSumsCoverableDetailsConfig };
